/**
 * kbStore.ts — static Knowledge Base config helper.
 *
 * All live KB data now flows through TanStack Query hooks in lib/kbApi.ts
 * (documents · graph · query · reviews · lint, all backed by wiki-llm-service).
 * The only thing left here is the static domain registry the UI reads for
 * labels/colors. (History: this was a reactive mock store ported from the
 * prototype's `window.CME_KB` IIFE; the B1b synthesis wiring replaced every
 * data read + mutation with real endpoints — see git for the old shape.)
 */
import { MOCK_KB_DOMAINS, type KbDomain } from "./mock";

export const kbStore = {
  /** Look up a domain's display config (label + color) by key. */
  domain: (key: string): KbDomain | undefined => MOCK_KB_DOMAINS.find((d) => d.key === key),
};
